import React from 'react';
import Blog from './Template/Blog';
import { Typography, Box, Link, Divider } from '@mui/material';

const ExampleBlog = () => {
    const blogData = {
        title: "[Blog Post Title]",
        author: "[Author Name]",
        date: "2025-04-01",
        heroImage: "/images/blogs/example/hero.webp",
        content: (
            <>
                <Box sx={{ mb: 6 }}>
                    <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                        [Introduction paragraph goes here. This should be a compelling opening that draws the reader in and explains what they'll learn from this article.]
                    </Typography>
                </Box>

                <section id="section1">
                    <Typography variant="h4" gutterBottom sx={{
                        fontWeight: 600,
                        color: '#1a1a1a',
                        mb: 3
                    }}>
                        1. [First Section Title]
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                        [First section content goes here. Include <strong>key points</strong> and relevant information.]
                    </Typography>
                </section>

                <Divider sx={{ my: 4 }} />

                <section id="section2">
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: '#1a1a1a', mb: 3 }}>
                        2. [Second Section Title]
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                        [Second section content goes here. Add <strong>important details</strong> and examples.]
                    </Typography>
                </section>

                <Divider sx={{ my: 4 }} />

                <section id="section3">
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: '#1a1a1a', mb: 3 }}>
                        3. [Third Section Title]
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                        [Third section content goes here.]
                    </Typography>
                    <Box sx={{
                        bgcolor: '#f8f9fa',
                        p: 3,
                        borderRadius: 2,
                        border: '1px solid #e9ecef',
                        my: 3
                    }}>
                        <Typography variant="body1" sx={{ color: '#495057' }}>
                            💡 <strong>Pro Tip:</strong> [Add a helpful tip or insight here]
                        </Typography>
                    </Box>
                </section>

                <section id="conclusion">
                    <Box sx={{
                        bgcolor: '#f8f9fa',
                        p: 4,
                        borderRadius: 2,
                        mt: 6,
                        border: '1px solid #e9ecef'
                    }}>
                        <Typography variant="h4" gutterBottom sx={{ color: '#1a1a1a', fontWeight: 600 }}>
                            [Conclusion Title]
                        </Typography>
                        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                            [Conclusion content goes here. Summarize key points and include a call to action.]
                            <Link href="[CTA URL]" color="primary">[CTA Text]</Link>
                        </Typography>
                    </Box>
                </section>
            </>
        ),
        tableOfContents: [
            { id: 'section1', title: '1. [First Section]' },
            { id: 'section2', title: '2. [Second Section]' },
            { id: 'section3', title: '3. [Third Section]' },
            { id: 'conclusion', title: 'Conclusion' }
        ],
        recommendedPosts: [
            { title: '[Related Post 1]', url: '/blogs/post-1' },
            { title: '[Related Post 2]', url: '/blogs/post-2' },
            { title: '[Related Post 3]', url: '/blogs/post-3' },
            { title: '[Related Post 4]', url: '/blogs/post-4' }
        ],
        meta: {
            description: "[Meta description of the blog post]",
            keywords: "[keyword1], [keyword2], [keyword3]",
            ogImage: "/images/blogs/example/hero.webp",
            canonical: "https://www.getmarter.com/blogs/post-url",
            socialSharing: {
                facebook: `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
                twitter: `https://twitter.com/intent/tweet?url=${window.location.href}`,
                linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`,
                whatsapp: `https://api.whatsapp.com/send?text=${window.location.href}`,
                telegram: `https://t.me/share/url?url=${window.location.href}`,
                reddit: `https://www.reddit.com/submit?url=${window.location.href}&title=${document.title}`
            }
        }
    };

    return <Blog {...blogData} />;
};

export default ExampleBlog;